module.exports = __webpack_public_path__ + "img/logo2.1c669882.jpg";